/* eslint-disable unicorn/consistent-function-scoping */
import { t } from "@lingui/macro";
import { ResumeDto } from "@reactive-resume/dto";
import { ResumeData } from "@reactive-resume/schema";
import { Button, Label, RichInput } from "@reactive-resume/ui";
import dayjs from "dayjs";
import { useState } from "react";
import { LuLoaderCircle } from "react-icons/lu";

import useAjaxOptimization from "@/client/hooks/use-ajax-optimization";
import { useToast } from "@/client/hooks/use-toast";
import getClearCustomFields from "@/client/libs/get-clear-custom-fields";
import { parseDataToResume } from "@/client/libs/parse-data-to-resume/index";
import { postToParent } from "@/client/post-to-parent-utils";
import { useResumeStore } from "@/client/stores/resume";

import { getSectionIcon } from "../../shared/section-icon";

export const SecOptimization = () => {
  const resume = useResumeStore((state) => state.resume);

  const [value, setValue] = useState<string | undefined>();

  const { loading, doAjax } = useAjaxOptimization();

  const [replaceLoading, setReplaceLoading] = useState(false);

  const [copyLoading, setCopyLoading] = useState(false);

  const { toast } = useToast();

  const action = async () => {
    if (!value) {
      return null;
    }

    let res: string | null = null;

    const jsonData = JSON.stringify(resume.data);

    res = await doAjax(jsonData, value);

    if (!res) {
      return null;
    }
    let resumeResult: ResumeData | null = null;
    try {
      const resJson = JSON.parse(res);

      const object = parseDataToResume(resume.data, resJson);
      // resumeResult = resumeDataSchema.parse(object);
      resumeResult = object;
    } catch (error) {
      console.log(error);
    }

    if (!resumeResult) {
      toast({
        variant: "error",
        title: t`SecOptimizationError`,
      });
      return resumeResult;
    }
    let result: ResumeDto = {
      ...resume,
      data: resumeResult,
      updatedAt: dayjs().valueOf().toString(),
    };
    result = getClearCustomFields(result);
    return result;
  };

  const onClickSubmitCopy = async () => {
    setCopyLoading(true);
    const result = await action();
    if (!result) {
      setCopyLoading(false);
      return;
    }
    result.createdAt = result.updatedAt;
    postToParent("CREATE_NEW_RESUME", result);
    setCopyLoading(false);
  };

  const onClickSubmitReplace = async () => {
    setReplaceLoading(true);
    const result = await action();
    if (!result) {
      setReplaceLoading(false);
      return;
    }
    useResumeStore.setState({
      resume: result,
    });
    postToParent("SAVE_TO_DB", result.data);
    setReplaceLoading(false);
  };

  return (
    <section id="sec-optimization" className="grid gap-y-6">
      <header className="flex items-center justify-between">
        <div className="flex items-center gap-x-4">
          {getSectionIcon("sec-optimization")}
          <h2 className="line-clamp-1 text-3xl font-bold">{t`SecOptimization`}</h2>
        </div>
      </header>

      <main className="grid gap-y-4">
        <div className="space-y-1.5">
          <Label>
            {t`SecOptimizationInfo`}
            <br />
            {t`SecOptimizationInfo2`}
          </Label>
          <RichInput
            hideToolbar={true}
            content={value}
            onChange={(e) => {
              setValue(e);
            }}
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <Button
            variant="outline"
            disabled={!value || loading}
            className="flex h-12 items-center justify-center overflow-hidden rounded border text-center text-sm ring-primary transition-colors hover:bg-secondary-accent focus:outline-none focus:ring-1 disabled:opacity-100"
            onClick={onClickSubmitCopy}
          >
            {copyLoading && <LuLoaderCircle className="mr-3 size-4 animate-spin" />}
            {t`SecOptimizationSubmitCopy`}
          </Button>
          <Button
            variant="outline"
            disabled={!value || loading}
            className="flex h-12 items-center justify-center overflow-hidden rounded border text-center text-sm ring-primary transition-colors hover:bg-secondary-accent focus:outline-none focus:ring-1 disabled:opacity-100"
            onClick={onClickSubmitReplace}
          >
            {replaceLoading && <LuLoaderCircle className="mr-3 size-4 animate-spin" />}
            {t`SecOptimizationSubmitReplace`}
          </Button>
        </div>
        {/* <div className="space-y-1.5">
          <div className="flex items-center gap-x-4">
            <Switch
              id="visibility"
              checked={isPublic}
              onCheckedChange={(checked) => {
                setValue("visibility", checked ? "public" : "private");
              }}
            />
            <div>
              <Label htmlFor="visibility" className="space-y-1">
                <p>{t`Public`}</p>
                <p className="text-xs opacity-60">
                  {t`Anyone with the link can view and download the resume.`}
                </p>
              </Label>
            </div>
          </div>
        </div>

        <AnimatePresence presenceAffectsLayout>
          {isPublic && (
            <motion.div
              layout
              className="space-y-1.5"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <Label htmlFor="resume-url">{t`URL`}</Label>

              <div className="flex gap-x-1.5">
                <Input readOnly id="resume-url" value={url} className="flex-1" />

                <Tooltip content={t`Copy to Clipboard`}>
                  <Button size="icon" variant="ghost" onClick={onCopy}>
                    <CopySimple />
                  </Button>
                </Tooltip>
              </div>
            </motion.div>
          )}
        </AnimatePresence> */}
      </main>
    </section>
  );
};
